import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import VendorDashboard from '../../../components/VendorUser/VendorDashboard';
import ShowAllPost from '../../../components/Post/ShowAllPost';
import PostDetilas from '../../../components/Post/PostDetilas';
import CreatePostWithOutCat from '../../../components/ProviderUser/CreatePostWithOutCat';
import VendorSidebar from '../../../Container/VendorSidebar/VendorSidebar';
import VendorProfile from '../../../components/VendorUser/VendorProfile';

const VendorRoutes = () => {
  return (
    <div>        
        <VendorSidebar/>
        <div style={{marginLeft:280,marginTop:25}}>
        <Routes>
            <Route path='/vendor-dashboard' element={<VendorDashboard />} />       
            <Route path='/user-profile/:id' element={<VendorProfile />} />       
            {/* <Route path='/provider-inspire-announcement' element={<ProviderInspireAnnouncements />} />  */}
            {/* <Route path="/subcategories/subcategory/:id" element={<ShowAllPost />} />  */}
            <Route path='/sub-category/:id' element={<ShowAllPost />} />
            <Route path='/post-details/:id' element={<PostDetilas />} />
            <Route path='/create-post' element={<CreatePostWithOutCat />} />
            {/* <Route path='/user-profile/:id' element={<ProviderProfile />} /> */}
           
                       
        </Routes>
    </div>
    </div>
  )
}

export default VendorRoutes